import { global_merch_carousel } from '../../utils/requests/contentstack/contentStackZodSchema';
import { type MerchCarouselProps } from './MerchCarousel';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';
export const merchCarouselSchema = global_merch_carousel.transform<MerchCarouselProps>(data => ({
  merchHeader: {
    title: data.header.title,
    description: data.header.description,
    descriptionLinks: data.header.description_links.map(descriptionLink => {
      return {
        href: descriptionLink.href,
        text: descriptionLink.title
      };
    })
  },
  items: data.items.map<MerchCarouselProps['items'][number]>(item => {
    return {
      bottomText: item.bottom_text,
      textBgColor: item.text_background_color,
      topText: item.top_text,
      image: getCloudinaryImageFields({
        alt: item.image.alt,
        cloudinaryField: item.image.src,
        shouldUseV2: true
      }),
      href: item.link?.href ?? ''
    };
  })
}));